module.exports = __webpack_public_path__ + "static/media/silhueta.3a7be3dc.svg";